<template>
  <div
    v-if="showCompontent"
    class="hotRecruitmentCompany_wrap"
    :style="{ backgroundImage: `url(${moduleIconUrl})` }"
  >
    <div class="header">
      <span
        class="header_title"
        :style="{
          textShadow: `0px 2px 8px ${buttonColor}`,
        }"
        >{{ componentConfig?.title }}</span
      >
      <span
        class="header_desc"
        :style="{ textShadow: `0px 2px 8px ${buttonColor}` }"
        >{{ componentConfig?.subtitle }}</span
      >
    </div>
    <div class="content" v-if="loading && companyInfoList?.length === 0">
      <div class="empty" :class="isForPC&&'empty_pc'">
        <div class="skeleton"></div>
      </div>
    </div>
    <Empty v-else-if="!loading && companyInfoList?.length === 0" />
    <template v-else>
      <div class="company_wrap">
        <div
          class="content"
          v-for="(item, index) in companyInfoList"
          :key="index"
        >
          <div
            class="content_company sensors_exposure"
            @click="toCompDetail(item, index)"
            sensorsname="CompanyShortExposure"
            :sensorsdata="
              $base.getCompanyShortExposureData(
                item,
                index,
                componentConfig?.showThread
              )
            "
          >
            <div class="company_info">
              <div class="company_nameAndDesc">
                <div class="company_name">
                  <span>{{ item.companyName }}</span>
                  <img src="@/assets/img/activity/arrow@2x.png" alt="" />
                </div>
                <div class="company_desc">
                  <div class="company_tag" v-if="item.isModelEmployer">
                    <!-- 优选雇主 -->
                    <img
                      src="@/assets/img/activity/employer_icon@2x.png"
                      alt=""
                    />
                  </div>
                  <span>{{ item.companyTypeString }}</span>
                  <span v-if="item.companySizeString"
                    >&nbsp;|&nbsp;{{ item.companySizeString }}</span
                  >
                </div>
                <div class="company_recommended_reason" v-if="getRecommendTip(item)&&isForPC">
                  <div class="icon_info">
                    <img src="@/assets/img/activity/icon_hand@3x.png" alt="" />
                    <span>推荐理由：</span>
                  </div>
                  <div class="recommended_reason_info">
                    {{ getRecommendTip(item) }}
                  </div>
                </div>
              </div>
              <div class="company_logo">
                <img :src="item.companyLogo" alt="" />
              </div>
            </div>
            <div class="company_recommended_reason" v-if="getRecommendTip(item)&&!isForPC">
              <div class="icon_info">
                <img src="@/assets/img/activity/icon_hand@3x.png" alt="" />
                <span>推荐理由：</span>
              </div>
              <div class="recommended_reason_info">
                {{ getRecommendTip(item) }}
              </div>
            </div>
          </div>
          <div
            class="question_and_answer"
            v-if="
              componentConfig?.showThread === 1 &&
              item.isSomeXyz &&
              item.questionList
            "
          >
            <div class="line"></div>
            <div
              class="no_question"
              v-if="item.questionList?.length === 0"
              @click.stop="toQuestion(item, 1)"
            >
              <div>
                <img src="@/assets/img/activity/avatar@3x.png" alt="" />
                <span>听听公司员工怎么说，去提问</span>
              </div>
              <img src="@/assets/img/activity/icon-right@3x.png" alt="" />
            </div>
            <div class="has_question" v-else>
              <div class="question_btn">
                <img src="@/assets/img/activity/qabg@3x.png" alt="" />
                <div @click.stop="toQuestion(item, 2)">去提问</div>
              </div>
              <div @click.stop="toqaList(item)">
                <div
                  class="question_info_item"
                  v-for="(q, index) in item.questionList"
                  :key="index"
                >
                  <div class="question_info">
                    <img src="@/assets/img/activity/question1@3x.png" alt="" />
                    <span>{{ q.description }}</span>
                  </div>
                  <div class="answer_info">
                    {{ answerNum(q.answerTotalCount) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="company_job">
            <div
              class="content_job sensors_exposure"
              v-for="(i, index) in item.jobInfo"
              :key="index"
              sensorsname="JobShortExposure"
              :sensorsdata="
                $base.getJobShortExposureData(
                  {
                    ...i,
                    pageCode: `YC|${$route.params.pageId}|${componentConfig.sort}|${componentConfig.type}|joblist|${componentConfig.id}|${pageConfig.activityZoneId}`,
                    shortPageCode: `YC|${$route.params.pageId}|${componentConfig.sort}|${componentConfig.type}|joblist|${componentConfig.id}|${pageConfig.activityZoneId}`,
                  },
                  index
                )
              "
              @click="toJobDetail(i, index, item.jobInfo?.length)"
            >
              <div class="job_nameAndPay">
                <span>{{ i.jobName }}</span>
                <span class="job_pay">{{ i.provideSalaryString }}</span>
              </div>
              <div class="job_tag_wrap" v-if="i.jobTags?.length > 0">
                <div class="tag_div">
                  <div
                    class="job_tag"
                    v-for="(j, index) in i.jobTags"
                    :key="index"
                    :style="{ display: !j ? 'none' : 'block' }"
                  >
                    {{ j }}
                  </div>
                </div>
              </div>
              <div class="job_address">
                <span>{{
                  i.workAreaCode != "999999" ? i.jobAreaString : "远程办公"
                }}</span>
                <template v-if="i.isFromXyx || !platform.includes('App')">
                  <div
                    class="custom_button toSend"
                    :class="{ sendState: i.isApply }"
                    @click.stop="toApply(item.coId, i)"
                  >
                    <img
                      v-if="!i.isApply"
                      src="@/assets/img/activity/send-white@2x.png"
                      alt=""
                    />
                    <span>{{ i.isApply ? "已投递" : "投递" }}</span>
                  </div>
                </template>
                <template v-else>
                  <div
                    class="custom_button"
                    v-if="componentConfig?.buttonType === 1"
                    @click.stop="toChat(i)"
                  >
                    去聊聊
                  </div>
                  <div
                    class="custom_button toSend"
                    :class="{ sendState: i.isApply }"
                    @click.stop="toApply(item.coId, i)"
                    v-if="componentConfig?.buttonType === 2"
                  >
                    <img
                      v-if="!i.isApply"
                      src="@/assets/img/activity/send-white@2x.png"
                      alt=""
                    />
                    <span>{{ i.isApply ? "已投递" : "投递" }}</span>
                  </div>
                </template>
              </div>
            </div>           
          </div>

        </div>
      </div>

    </template>
    <div class="see_more" v-if="pageNum !== 1">
      <div
        v-if="!loading && pageNum <= totalPages"
        @click="seeMoreFun"
        class="see_more_btn"
      >
        <span>查看更多</span>
        <img src="@/assets/img/activity/down@3x.png" alt="" />
      </div>
      <div v-if="loading">
        <img
          src="@/assets/img/activity/loading@2x.png"
          alt=""
          class="loading_img"
        />
        <span>正在加载…</span>
      </div>
    </div>
    <div v-if="errorMsg" class="error_msg">{{ errorMsg }}</div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Empty from "../common/EmptyData.vue";
export default {
  name: "CompanyAndJobList",
  components: {
    Empty,
  },
  props: {
    componentConfig: {
      type: Object,
      default: () => {},
    },
    pageConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showCompontent: true,
      loading: false,
      pageNum: 1,
      totalPages: 0,
      companyInfoList: [],
      requestId: "",
      jobOrCompanyIdList: [],
      errorMsg: "",
      isFirstInit:false
    };
  },
  computed: {
    ...mapState(["commonStore","resumeStore"]),
    platform() {
      return this.commonStore.platform;
    },
    isForPC() {
      return this.commonStore.isForPC;
    },
    backgroundConfigDTO(){
      return this.componentConfig.backgroundConfigDTO
    },
    buttonColor(){
      return this.backgroundConfigDTO?.buttonColor||this.pageConfig.buttonColor
    },
    moduleIconUrl(){
      if(this.commonStore.isForPC){
        return this.backgroundConfigDTO?.moduleIconPcUrl||this.pageConfig.moduleIconPcUrl
      }else{
        return this.backgroundConfigDTO?.moduleIconUrl||this.pageConfig.moduleIconUrl
      }
    },
    needFilterJobs(){//是否当前组件需配置了推荐
      if(this.componentConfig.recommendConfigDTO){
        return this.componentConfig.recommendConfigDTO.needFilterJobs;
      }else if(this.pageConfig.recommendConfigDTO && this.pageConfig.recommendConfigDTO.needFilterJobs){
        return true;
      }else{
        return false;
      }
    }
  },
  watch: {
    "commonStore.currentAreaCode": {
      handler(newVal) {
        if (!newVal) return;
        this.isFirstInit = false;
        this.loading = false;
        this.pageNum = 1;
        this.totalPages = 0;
        this.companyInfoList = [];
        this.requestId = "";
        this.jobOrCompanyIdList = [];
        this.errorMsg = "";
        this.queryList();
      },
      immediate: false,
    },
    "commonStore.deweightComponentSort":{//监控去重顺序变更
      handler(val) {
        if(val == this.componentConfig.deWeightSort){//轮到本组件加载数据了
          console.log("触发-----监控去重-----顺序变更4444",val)
          console.log("触发-----公司职位组件-----顺序",this.componentConfig.deWeightSort);
          this.isFirstInit = true;
          this.queryList();
        }
      },
      immediate: false,
    }
  },
  methods: {
    ...mapActions("applyJobStore", ["applyJob", "batchApplyJob"]),
    toCompDetail(item, index) {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_colist",
        moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
        contentName: this.componentConfig.title,
        contentType: "公司",
        contentId: item.coId,
        contentRank: `${index}`,
        bcopExrinfo: {
          pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|colist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
        },
      });
      if (
        !["yjsM", "yjsPC"].includes(this.platform) &&
        !this.$base.checkLoginStatus(true)
      )
        return;
      this.$base.toCompanyDetail(item, index, true);
    },
    toJobDetail(i, index, length) {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_joblist",
        moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
        contentName: this.componentConfig.title,
        contentType: "职位",
        contentId: i.jobId,
        contentRank: `${index}`,
        requestId: JSON.parse(i.property).requestId || '',
        bcopExrinfo: {
          pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
        },
      });

      if (!this.$base.checkLoginStatus(true)) return;
      this.$base.toJobDetail(i, index, length);
    },
    toChat(item) {
      if (!this.$base.checkLoginStatus(true)) return;
      this.$base.goChatNew(item, this.commonStore, {
        pageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
      });
    },
    toApply(coId, item) {
      if (!this.$base.checkLoginStatus(true)) return;
      if (item.isApply) return;
      if (item.isFromXyx) {
        this.toJobDetail(item);
        return;
      }
      // 单投
      const property = (item?.property && JSON.parse(item.property)) || {};
      const params = {
        item: { ...item, jobId: String(item.jobId) },
        property: {
          ...property,
          pageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
          shortPageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
          fromModule: "列表单投",
        },
        isShowToast: "0",
        onSuccess: () => {
          this.$emit("goQuestionSet", [item]);
          this.changeItemIsApply(coId, item);
          this.$store.commit("setValueLocalStorage", {
            applyJobRefreshTasks:
              this.$store.state.commonStore.applyJobRefreshTasks + 1,
          });
        },
      };
      this.applyJob(params);
    },
    // 投递成功后按钮展示已投递
    changeItemIsApply(cId, item) {
      const comInfo = this.companyInfoList.find(({ coId }) => coId === cId);
      comInfo.jobInfo.find(({ jobId }) => jobId === item.jobId).isApply = true;
    },
    async queryList() {
      console.log("公司：needFilterJobs",this.needFilterJobs)
      this.loading = true;
      const params = {
        componentId: this.componentConfig?.id,
        cityCode: this.commonStore.currentAreaCode,
        funcCode: this.$route.query?.funcCode
          ? this.$route.query.funcCode
          : this.commonStore.intention?.expectFunction || "",
        requestId: this.requestId,
        jobOrCompanyIdList: this.jobOrCompanyIdList,
        pageNum: this.pageNum,
        pageSize: this.componentConfig?.companyNumber,
        workFuncStr: this.commonStore.intention?.expectFunctionString,
        expectWorkArea: this.commonStore.intention?.expectArea,
        expectIndustry: this.commonStore.intention?.expectIndustry,
        expectIndustryNew: this.commonStore.intention?.expectIndustry,
        expectMinSalary: this.commonStore.intention?.minSalary,
        expectMaxSalary: this.commonStore.intention?.maxSalary,
        busBelong: this.pageConfig.busBelong || "51job",
        seekType: this.commonStore.intention?.seekType || "",
        userIdentity:
          this.commonStore.identityType == "职场人"
            ? 0
            : this.commonStore.identityType == "在校生"
            ? 1
            : 0,
        degree:this.resumeStore.resume?.c.education[0]?.degree || '',
        major:this.resumeStore.resume?.c.education[0]?.major || ''  ,
        filterJobIds:(this.isFirstInit && this.needFilterJobs) ? (JSON.parse(sessionStorage.getItem("filterJobIds"))|| null):null//过滤ids    
      };
      const property = {
        pageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|colist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
        shortPageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|colist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
        pageNum: this.pageNum,
      };
      const res = await this.$api.activity.getActivityCompanyList(params, {
        property,
      });
      // 首屏去重职位逻辑:请求完数据,加载下一个需要去重的组件
      if(this.isFirstInit){//首次加载数据
        this.isFirstInit = false;
        this.$base.setFilterJobIds(this.componentConfig.deWeightSort,res.data?.companyInfoList?.result);
      }
      if (+res?.code == "0") {
        const {
          requestId,
          jobOrCompanyIdList,
          companyInfoList: { result = [], totalPages } = {},
        } = res.data;
        this.requestId = requestId;
        this.jobOrCompanyIdList = jobOrCompanyIdList;

        if (!result?.length && this.pageNum == 1) {
          this.showCompontent = false
          this.$store.commit('subCountJobAndCompany')
        }

        if (this.componentConfig?.showThread === 1 && result?.length > 0) {
          const newResult = await this.getQuestionList(result);
          this.companyInfoList.push(...newResult);
        } else {
          this.companyInfoList.push(...result);
        }
        this.totalPages = totalPages;
        this.pageNum++;
        this.loading = false;
        this.$nextTick(() => {
          this.$exposure.sensorsExposure();
        });
      } else {
        this.errorMsg = res?.msg;
        this.loading = false;
      }
    },
    async getQuestionList(data) {
      const params = {
        componentId: this.componentConfig?.id,
        pageSize: 2,
        pageNum: 1,
        coIdList: data.map(({ coId }) => coId),
        type: 2,
        sortType: [2, 1],
      };
      const res = await this.$api.activity.getQuestionList(params);
      if (+res?.code == "0" && res?.data) {
        const { questionMap = {} } = res.data || {};
        const result = data.map((item) => {
          const { questionInfoList } = questionMap[item.coId] || {};
          return {
            ...item,
            questionList: questionInfoList || [],
            isSomeXyz:
              item.jobInfo.some(({ isFromXyx }) => !isFromXyx) ||
              item.jobInfo?.length === 0,
          };
        });
        return result;
      } else {
        return data;
      }
    },
    getRecommendTip(item) {
      //职位来源：1-文件导入 2-搜推职位搜索
      const { sesameLabelList, recommendTip } = item;
      const sesameLabelListData = sesameLabelList || [];
      const sesameLabel = sesameLabelListData
        .map(({ labelName }) => labelName)
        .filter((i) => i)
        .join(",");
      if (this.componentConfig?.jobSource === 1) {
        return recommendTip || sesameLabel || "";
      }
      return sesameLabel || "";
      // return '五险一金，包住宿，周末双休，包住宿，周末双休，准时准时发工资啊，包住宿，周末双休，准时发工资啊，同事氛围好，周末双休，准时发工资啊'
    },
    seeMoreFun() {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_colist_more",
        moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
        contentName: this.componentConfig.title,
        bcopExrinfo: {
          pagecoe: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|colist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
        },
      });
      this.queryList();
    },
    toQuestion(item, type) {
      if (!this.$base.checkLoginStatus(true)) return;
      const element_id =
        type == 1
          ? "sensor_bcop_colist_askbanner"
          : "sensor_bcop_colist_askbutton";
      this.$sensors.track("$WebClick", {
        $element_id: element_id,
        moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
        contentName: this.componentConfig.title,
        bcopExrinfo: {
          pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|colist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
        },
      });

      this.$router.push({
        path: "/askQuestion",
        query: {
          coId: item.coId,
          coName: item.companyName,
          activityId: this.$route.params.pageId,
          type: 2,
          componentId: this.componentConfig?.id,
          jobSource: this.componentConfig?.jobSource,
          ctmId: item.ctmId,
        },
      });
    },
    toqaList(item) {
      if (!this.$base.checkLoginStatus(true)) return;
      // 1-活动下的问答；2-公司下的问答；3-职位下的问答
      this.$router.push({
        path: "/questionAndAnswerList",
        query: {
          id: item.coId,
          activityId: this.$route.params.pageId,
          componentId: this.componentConfig?.id,
          type: 2,
          jobSource: this.componentConfig?.jobSource,
        },
      });
    },
    answerNum(num) {
      if (!num) return "暂无回答";
      if (num > 99) {
        return "共99+个回答";
      } else {
        return `共${num}个回答`;
      }
    },
  },
  mounted() {
    // sessionStorage.removeItem("filterJobIds");
    // console.log("触发公司职位组件顺序",this.componentConfig.sort);
    // this.queryList();
  },
};
</script>
<style src="./index.less" scoped lang="less" />
